import { useLayoutEffect, useState, type RefObject } from 'react';
import { monthCellRows } from './calendar.logic';

/** How many chip rows each of the grid's cells holds, kept current as the
 *  window resizes. Whole rows, so a resize re-renders the cells only when
 *  their fit changes. */
export function useMonthCellRows(gridRef: RefObject<HTMLDivElement | null>, weeks: number): number {
  const [rows, setRows] = useState(0);
  useLayoutEffect(() => {
    // The grid renders with the view, so the ref is set by now.
    const grid = gridRef.current!;
    const measure = (height: number) => setRows(monthCellRows(height / weeks));
    measure(grid.getBoundingClientRect().height);
    const observer = new ResizeObserver((entries) => measure(entries[0]!.borderBoxSize[0]!.blockSize));
    observer.observe(grid);
    return () => observer.disconnect();
  }, [gridRef, weeks]);
  return rows;
}
